import React, { useState } from "react";
import {
  SafLogo,
  SafText,
  SafToolbar,
  SafIcon,
} from "@saffron/core-components/react";
import { Link, useNavigate } from "react-router-dom";
import "../../css/header.css";

const Header = ({ userData, handleLogout }) => {
  const [showLogoutBox, setShowLogoutBox] = useState(false);
  const navigate = useNavigate();

  const toggleLogoutBox = () => {
    setShowLogoutBox((prev) => !prev);
  };
  const handleUserLogout = () => {
    localStorage.clear();
    sessionStorage.clear();
    document.cookie = "authSession=; expires=Thu,01 Jan 1970 00:00:UTC;path=/;";
    document.cookie = "session_id=; expires=Thu,01 Jan 1970 00:00:UTC;path=/;";
    handleLogout();
    navigate("/logged-out");
  };
  // const name = props;
  // console.log(name);

  // const location = useLocation();
  // console.log(location.pathname, location.key, location);

  // const keyName = location.search.split("=")[1];
  // const keyName =
  //   "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJhY2Nlc3NfdG9rZW4iOiIwMDAxcTRtMU1DakxCTktKZUdPOHJ6cU96Z2pqIiwidXNlcmluZm8iOnsic3ViIjoiQzI5NzgzMyIsInRob21zbmFtZWRpc3BsYXkiOiJDaGludGhhLCBMYWtzaG1pdmlnbmVzd2FyaSIsIm1haWwiOiJMYWtzaG1pdmlnbmVzd2FyaS5DaGludGhhQHRob21zb25yZXV0ZXJzLmNvbSIsImxlZ2FsbmFtZSI6Ikxha3NobWl2aWduZXN3YXJpIiwiZ2l2ZW5OYW1lIjoiTGFrc2htaXZpZ25lc3dhcmkiLCJ0aG9tc2J1bGV2ZWwxZGVzY3IiOiJUZWNobm9sb2d5IC0gQ0lPLUFMTCIsImNuIjoiTGFrc2htaXZpZ25lc3dhcmkgQ2hpbnRoYSIsInRpdGxlIjoiQ29udHJhY3RvciIsInRob21zc3VwZXJ2aXNvcmRlc2NyIjoiQmVyZywgTWljaGFlbCIsImVtcGxveWVlTnVtYmVyIjoiQzI5NzgzMyIsInZkZG4iOlsidWlkPUMyOTc4MzMsb3U9UGVvcGxlLG89dGhvbXNvbi5jb20iLCJDTj1DMjk3ODMzLE9VPVVzZXIgQWNjb3VudHMsT1U9TVNQMDEsZGM9ZWFkLGRjPXRob21zb25yZXV0ZXJzLGRjPWNvbSJdLCJ1aWQiOiJDMjk3ODMzIiwidGhvbXNzdXBlcnZpc29yaWQiOiIwMDEzOTY1IiwidGhvbXNQcmVmTmFtZSI6Ikxha3NobWl2aWduZXN3YXJpIiwidGhvbXNSZWNvcmRUeXBlIjoiQ09OIiwic24iOiJDaGludGhhIiwidGhvbXNjaGFyZ2ViYWNrIjoiMjUxMTMifSwiZXhwIjoxNzM5ODAxODIwfQ.w-qAlcEMkZPPJ8lz5GfHzbCSgGvc25hwm9QmLxPvHAE";
  // var decoded = jwtDecode(keyName);
  return (
    <div className="header">
      <SafToolbar aria-label="Overview toolbar">
        <div slot="top-row-start">
          <div>
            <Link to="/home">
              <SafLogo />
            </Link>
          </div>
          <div className="header-title">
            <SafText>Architecture Enablement Application</SafText>
          </div>
        </div>
        <div slot="top-row-end">
          <div
            className="user-info-container"
            style={{ display: "flex", justifyContent: "flex-end" }}
          >
            <div className="user-logo" onClick={toggleLogoutBox}>
              <SafIcon iconName="user" size="small" />
              <span className="user-greeting">
                Hello,{" "}
                {userData
                  ? `${userData.firstName} ${userData.lastName}`
                  : "User"}
              </span>
              <SafIcon iconName="chevron-down" size="small" />
            </div>
            {showLogoutBox && (
              <div className="logout-box">
                <button onClick={handleUserLogout}>Logout</button>
              </div>
            )}
          </div>
        </div>
      </SafToolbar>
    </div>
  );
};

export default Header;
